module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": "",
      "md4": "",
      "offset-md4": ""
    }
  }, [_c('div', {
    staticClass: "my-5 display-1"
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('v-text-field', {
    ref: "email",
    attrs: {
      "tabindex": "1",
      "label": "email",
      "required": "",
      "autocomplete": "email"
    },
    on: {
      "input": function($event) {
        _vm.error = false
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "tabindex": "2",
      "label": "lozinka",
      "required": "",
      "autocomplete": "current-password",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password'
    },
    on: {
      "input": function($event) {
        _vm.error = false
      },
      "click:append": function () { return (_vm.showPassword = !_vm.showPassword); }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary my-5",
    attrs: {
      "large": "",
      "block": "",
      "tabindex": "3",
      "type": "submit",
      "disabled": !_vm.valid,
      "loading": _vm.loading
    }
  }, [_vm._v("login")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("registracija")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/resetPassword"
    }
  }, [_vm._v("zaboravljena lozinka?")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_vm._v("\n        Pogrešna kombinacija\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}